import React from 'react';
import PropTypes from 'prop-types';
import { USER_DATA } from '@/proptypes/index';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withConfig from '@/config/withConfig';
import { resetSelectedSpot } from 'store/spot/spot-actions';
import { userLogout } from 'store/user/user-actions';
import Navigation from '../../navigation';
import { Box } from '@spothero/ui';
import { headerStyles } from '../headerStyles';
import { expandedData, collapsedData } from '../constants';
import HeaderSearchDesktop from 'pages/search/components/header/HeaderSearch'; // Not sure how to handle better
import { useShowNewSearchHeader } from 'pages/search/hooks/use-show-new-search-header';
import { useCurrentPathname } from 'hooks/use-current-pathname';
// match width with the Search route
const PATHS_WITH_FULL_WIDTH_HEADER = ['/event-packages-search'];
const HeaderDesktop = ({ isProduction, user, clearSelectedSpot, onUserLogout, }) => {
    const showNewSearchHeader = useShowNewSearchHeader();
    const pathname = useCurrentPathname();
    const isFullWidth = PATHS_WITH_FULL_WIDTH_HEADER.includes(pathname);
    // short-circuit for search page
    if (showNewSearchHeader) {
        return <HeaderSearchDesktop />;
    }
    return (<Box {...headerStyles} as="header" role="banner" data-testid="Header">
            <Navigation 
    // @ts-expect-error Redux compose Typing mismatch
    isProduction={isProduction} user={user} collapsedData={collapsedData} expandedData={expandedData} onItemSelected={clearSelectedSpot} onUserLogout={onUserLogout} isFullWidth={isFullWidth}/>
        </Box>);
};
HeaderDesktop.propTypes = {
    className: PropTypes.string,
    isProduction: PropTypes.bool,
    user: PropTypes.shape(USER_DATA).isRequired,
    clearSelectedSpot: PropTypes.func.isRequired,
    onUserLogout: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
    const { user: { data: userData }, } = state;
    return {
        user: userData,
    };
};
const mapDispatchToProps = {
    clearSelectedSpot: resetSelectedSpot,
    onUserLogout: userLogout,
};
const enhance = compose(withConfig(['isProduction']), connect(mapStateToProps, mapDispatchToProps));
export default enhance(HeaderDesktop);
